<template>
  <svg width="18px" height="18px"><use :xlink:href="getAmenityIcon" /></svg>
</template>

<script>
export default {
  props: ["code"],
  computed: {
    getAmenityIcon() {
      const defaultSvg = "/img/sprite.svg#ic_done";

      switch (this.code) {
        case "ACRM":
          return "/img/sprite.svg#ic_ac";
        case "INET":
          return "/img/sprite.svg#ic_wifi";
        case "TV":
          return "/img/sprite.svg#ic_tv";
        case "RMSRV":
          return "/img/sprite.svg#ic_people";
        case "BATHRM":
          return "/img/sprite.svg#ic_bathroom";
        case "COTEA":
          return "/img/sprite.svg#ic_coffee";
        case "PVTPOOL":
          return "/img/sprite.svg#ic_pool";
        case "IDDCALL":
          return defaultSvg;
        case "VAULT":
          return "/img/sprite.svg#ic_safebox";
        case "MBAR":
          return "/img/sprite.svg#ic_wine";

        default:
          return defaultSvg;
      }
    },
  },
};
</script>
